export enum DataURLs {
  PNG = 'data:image/png;base64,',
  JPEG = 'data:image/jpeg;base64,',
  PDF = 'data:application/pdf;base64,',
}

export const dataUrl = {
  png:DataURLs.PNG,
  jpeg:DataURLs.JPEG,
  pdf:DataURLs.PDF,
  jpg:DataURLs.JPEG,
}

export enum mimeTypes {
  MIME_PNG = 'image/png',
  MIME_JPEG = 'image/jpeg',
  MIME_PDF = 'application/pdf'
}

export const mimeExtensions = {
  png:mimeTypes.MIME_PNG,
  jpeg:mimeTypes.MIME_JPEG,
  pdf:mimeTypes.MIME_PDF,
  jpg:mimeTypes.MIME_JPEG,
}
